export const realEstateTransactions = {
  columnParams: 'grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3rem]',
  columns: [
    [{ id: 'date', type: 'date', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm' }],
    [{ id: 'purchaseValue', type: 'currency0Decimals', classNamesBody: 'text-xs sm:text-sm' }],
    [{ id: 'currentValue', type: 'currency0Decimals', classNamesBody: 'text-xs sm:text-sm' }],
    [
      { id: 'dividendsSincePurchase', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },
      { id: 'fees', type: 'currency', hideHeaderLabel: true, classNamesBody: 'text-xs sm:text-sm' },
    ],
    [
      { id: 'roi', type: 'percentage', usesHeader: 'roiOnly', classNamesBody: 'text-xs sm:text-sm' },
      { id: 'roiAnnual', type: 'percentage', classNamesBody: 'text-xs text-gray-400' },
    ],
    [{ id: 'ellipsis', type: 'ellipsis', usesHeader: 'emptyString', classNamesBody: '-ml-3' }],
  ],
};

// see realEstateQuotes for an example of a table layout with some extra parameter
export const realEstateQuotes = {
  columnParams: 'grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr)] sm:grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr)]',
  columns: [
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      { id: 'source', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [{ id: 'source', type: 'string', classNamesBoth: 'hidden sm:block', textAlign: 'text-center' }],
    [
      { id: 'quoteBaseCurrency', usesHeader: 'price', type: 'currency0Decimals' }, // usesHeader: if found, the header and tooltip will use this element from the i18n file
      {
        id: 'pricePerSquareMetre',
        type: 'currency0Decimals',
        classNamesBoth: 'sm:hidden', // pass hide / show classes here, they will be applied to HeaderLabels and BodyColumns
        classNamesBody: 'text-xs', // pass extra classes here, they will be applied to BodyColumns only
      },
    ],
    [{ id: 'currency', type: 'string', classNamesBoth: 'hidden sm:block' }],
    [
      { id: 'quote', usesHeader: 'originalPrice', type: 'number0Decimals' },
      {
        id: 'originalPricePerSquareMetre',
        type: 'number0Decimals',
        classNamesBoth: 'sm:hidden', // pass hide / show classes here, they will be applied to HeaderLabels and BodyColumns
        classNamesBody: 'text-xs', // pass extra classes here, they will be applied to BodyColumns only
      },
      { id: 'currency', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [
      {
        // pass hide / show classes here, they will be applied to HeaderLabels and BodyColumns
        id: 'pricePerSquareMetre',
        type: 'currency0Decimals',
        classNamesBoth: 'hidden sm:block',
      },
    ],
    [{ id: 'originalPricePerSquareMetre', type: 'number0Decimals', classNamesBoth: 'hidden sm:block' }],
  ],
};
